import { useCallback, useMemo, useState } from "react";

import { OptionStockDiffStore } from "./option-stock-diff-store";
import { useUpdateOptionStock } from "../../repository/mutation/use-update-option-stock";

import type { ServerModel } from "./type";

type Props = {
	serverModel: ServerModel;
};

export const useCreateOptionStockFormModel = ({ serverModel }: Props) => {
	const [isValid, setIsValid] = useState(false);
	const [isDirty, setIsDirty] = useState(false);

	const optionStockDiffStore = useMemo(
		() => new OptionStockDiffStore(serverModel.optionStock.items, setIsValid, setIsDirty),
		[serverModel.optionStock.items],
	);

	const onReInitialize = useCallback(() => {
		setIsValid(false);
		setIsDirty(false);
		optionStockDiffStore.clear();
	}, [optionStockDiffStore]);

	const { onUpdateOptionStock } = useUpdateOptionStock({
		onReInitialize,
		serverModel,
		optionStockDiffStore,
	});

	return {
		isValid,
		isDirty,
		onUpdateOptionStock,
		onReInitialize,
		optionStockDiffStore,
	};
};
